import { DISPLAY_DATE_FORMAT } from 'Models/Constants';
import moment from 'moment';

export const displayFormatedDate = (
    date: string | undefined,
    format = DISPLAY_DATE_FORMAT
): string => moment.utc(date).format(format);
